import { Skeleton } from "@papier/ui/components/ui/skeleton";

export function PendingProjectsComponent() {
  return (
    <div className="flex h-[40vh] items-center justify-center">
      <p className="text-white">Loading org projects...</p>
    </div>
  );
}

export function PendingTemplatesComponent() {
  return (
    <section className="grid gap-8">
      <section className="grid gap-3">
        <Skeleton className="w-50 h-7" />
        <div className="grid h-[20vh] grid-cols-1 items-center justify-center gap-6 md:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="size-full" />
          ))}
        </div>
      </section>
      <section className="grid gap-3">
        <Skeleton className="w-50 h-7" />
        <div className="grid h-[20vh] grid-cols-1 items-center justify-center gap-6 md:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="size-full" />
          ))}
        </div>
      </section>
    </section>
  );
}

export function PendingProjectComponent() {
  return (
    <div className="flex h-[40vh] items-center justify-center">
      <p className="text-white">Loading project...</p>
    </div>
  );
}

export function PendingTemplateComponent() {
  return (
    <div className="flex h-[40vh] items-center justify-center">
      <p className="text-white">Loading template...</p>
    </div>
  );
}
export function PendingOrganizationComponent() {
  return (
    <div className="flex h-[40vh] items-center justify-center">
      <p className="text-white">Loading org settings...</p>
    </div>
  );
}
